const pub = {
  "pub.whatsapp_default_msg": "Bonjour, je suis intéressé(e) par un traitement à la Esteva Clinic.",
  "pub.error_title": "Une erreur s'est produite",
  "pub.error_message": "Veuillez recharger la page. Si le problème persiste, veuillez désactiver la traduction/les extensions du navigateur.",
  "pub.error_reload": "Recharger la page",
  "pub.pill_1": "Implants dentaires Albanie",
  "pub.pill_2": "Greffe de cheveux FUE",
  "pub.pill_3": "Rhinoplastie correction du nez",
  "pub.pill_4": "Augmentation mammaire",
  "pub.pill_5": "Lifting du visage",
  "pub.pill_6": "Liposuccion",
  "pub.pill_7": "Facettes couronnes en zircone",
  "pub.pill_8": "Botox acide hyaluronique",
  "pub.pill_9": "Abdominoplastie",
  "pub.pill_10": "Tourisme médical Albanie",
  "pub.pill_11": "70% moins cher qu'en Suisse",
  "pub.pill_12": "Clinique premium Tirana",
  "pub.country_albania": "Albanie",
  "pub.opening_hours_default": "Lun–Ven : 08:00–20:00 | Sam : 09:00–16:00 | Dim : Fermé",
  "pub.fkw_1": "Implants dentaires Albanie",
  "pub.fkw_2": "Couronnes en zircone",
  "pub.fkw_3": "Facettes",
  "pub.fkw_4": "Blanchiment des dents",
  "pub.fkw_5": "Greffe de cheveux FUE",
  "pub.fkw_6": "Augmentation mammaire Albanie",
  "pub.fkw_7": "Rhinoplastie correction du nez",
  "pub.fkw_8": "Botox Tirana",
  "pub.fkw_9": "Liposuccion Albanie",
  "pub.fkw_10": "Lifting du visage",
  "pub.fkw_11": "Abdominoplastie",
  "pub.fkw_12": "Lifting des seins",
  "pub.fkw_13": "Réduction mammaire",
  "pub.fkw_14": "Chirurgie des paupières",
  "pub.fkw_15": "BBL Albanie",
  "pub.fkw_16": "Chirurgie intime",
  "pub.fkw_17": "Chirurgie plastique Albanie",
  "pub.fkw_18": "Chirurgie esthétique Tirana",
  "pub.fkw_19": "Tourisme médical Albanie",
  "pub.fkw_20": "Tourisme dentaire",
  "pub.fkw_21": "70% moins cher qu'en Suisse",
  "pub.fkw_22": "70% moins cher qu'en Allemagne",
  "pub.fkw_23": "Dentiste à l'étranger",
  "pub.fkw_24": "Clinique premium Tirana",
  "pub.fkw_25": "Première consultation gratuite",
};

export default pub;
